module.exports = __webpack_public_path__ + "static/media/bg-yellowM.988a84eb.svg";